import { ButtonHTMLAttributes, useEffect, useState } from 'react'

import { LocalVideoTrack } from 'livekit-client'

import { useMaybeRoomContext } from '@/src/context'
import { BgEffect } from '@/src/lib/types'
import { BlurIcon } from '@/accets/icons'
import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

export interface BlurSwitcherProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  setBgEffect: (effect: BgEffect | null) => React.MouseEventHandler<HTMLButtonElement> | void
  currentBgEffect: BgEffect | null
  track: LocalVideoTrack
}

const radiuses: number[] = [10]

/** Читает сохранённый тип эффекта, не ломая предвход при повреждённом JSON или запрете хранилища. */
function readStoredBgEffectType(): string | undefined {
  try {
    if (typeof window === 'undefined') return undefined

    return JSON.parse(localStorage.getItem('lk-user-choices') || '{}')?.currentBgEffect?.type
  } catch {
    return undefined
  }
}

export function BlurSwitcher({ setBgEffect, currentBgEffect, track, ...props }: BlurSwitcherProps) {
  const bgEffectFromLocalStorage = readStoredBgEffectType()
  const [isActive, setIsActive] = useState<string>(
    bgEffectFromLocalStorage === 'background-blur' ? 'active' : '',
  )
  const { text_primary_color, border_radius: borderRadius } = useAppSelector(selectBranding)

  useEffect(() => {
    setIsActive(currentBgEffect?.type === 'background-blur' ? 'active' : '')
  }, [currentBgEffect])

  const maybeRoomContext = useMaybeRoomContext()
  useEffect(() => {
    if (bgEffectFromLocalStorage === 'background-blur' && currentBgEffect === null) {
      if ((!track && !maybeRoomContext) || track) {
        setBgEffect({
          type: 'background-blur',
          options: {
            blurRadius: 10,
          },
        })
      }
      setIsActive('active')
    }
  }, [])

  return radiuses.map((radius) => (
    <button
      key={radius}
      aria-label="Activate blur effect"
      className={['lk-button-bg-effects', isActive].join(' ')}
      style={{
        borderColor: isActive ? text_primary_color : 'transparent',
        borderRadius,
      }}
      onClick={() => setBgEffect({ type: 'background-blur', options: { blurRadius: radius } })}
    >
      <BlurIcon stroke={'red'} fill={text_primary_color} width={36} height={36} />
    </button>
  ))
}
